export default __webpack_public_path__ + "static/elastix-93d9982a90f43fceed2d066655b1a916.png";